import { render, staticRenderFns } from "./Tab-Promotion.vue?vue&type=template&id=340459a4"
import script from "./Tab-Promotion.vue?vue&type=script&lang=js"
export * from "./Tab-Promotion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports